module.exports = __webpack_public_path__ + "img/wechat_code.0f061c3f.jpg";